export enum ETipoImpressaoBoleto {
  Nenhum = 0,
  Geral = 1,
  Vendas = 2,
  Servicos = 3
}
